

import Container from "@/components/shared/Container";
import ProductGallery from "../elements/Product/ProductGallery";
import { MainShopProduct } from "@/core/models/shop-product-model";
import ProductInformation from "../elements/Product/ProductInformation";
import ProductDetailTabs from "../elements/Product/ProductDetailTabs";
import ProductComments from "../elements/comment/ProductComment";
import StickyCartBar from "../elements/Product/StickyCartBar";
import Link from "next/link";
import Image from "next/image";
import { Heading } from "@/components/ui/Heading";

interface GalleryData {
    image_info: Array<{
        url: string;
        alt?: string;
    }>;
}

interface ProductColor {
    product_id: string
    color_code: string
    color_code_2?: string
    color_title: string
}

interface ProductViewProps {
    product: MainShopProduct;
    gallery: GalleryData;
    colors: ProductColor[];
    id: number;
}

// Wood options
// Wood options – product_id as string
const DEMO_WOOD_OPTIONS = [
    { product_id: "10", color_code: "#5C3A21", color_title: "Walnut" },
    { product_id: "11", color_code: "#C4A97D", color_title: "Oak" },
    { product_id: "12", color_code: "#E8D5B7", color_title: "Beech" },
    { product_id: "13", color_code: "#3B2914", color_title: "Wenge" },
    { product_id: "14", color_code: "#8B6F4E", color_title: "Teak" },
]

// Fabric options – product_id as string
const DEMO_FABRIC_OPTIONS = [
    { product_id: "1", color_code: "#F5F0E8", color_code_2: "#4A4A48", color_title: "Ivory / Charcoal" },
    { product_id: "2", color_code: "#4A4A48", color_code_2: "#F5F0E8", color_title: "Charcoal / Ivory" },
    { product_id: "3", color_code: "#8B7355", color_code_2: "#2F4538", color_title: "Camel / Forest" },
    { product_id: "4", color_code: "#C2A78B", color_code_2: "#7B2D3F", color_title: "Sand / Burgundy" },
    { product_id: "5", color_code: "#1F3A5F", color_code_2: "#B8AFA6", color_title: "Navy / Stone" },
    { product_id: "6", color_code: "#E8DDD0", color_code_2: "#3C3C3C", color_title: "Cream / Graphite" },
    { product_id: "7", color_code: "#D4C8B8", color_code_2: "#6B5B4B", color_title: "Oat / Mocha" },
    { product_id: "8", color_code: "#F5F0E8", color_title: "Ivory Bouclé" },
    { product_id: "9", color_code: "#4A4A48", color_title: "Charcoal Linen" },
    { product_id: "15", color_code: "#8B7355", color_title: "Camel Suede" },
    { product_id: "16", color_code: "#2F4538", color_title: "Forest Velvet" },
]

export default function ProductView({ product, gallery, id }: ProductViewProps) {
    console.log("product", product);

    return (
        <div className="flex flex-col gap-12 px-0">
            {/* Main Product Section - Full width gallery with absolute info */}
            <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Full Width Gallery - در موبایل اول میاد */}
                <div className="col-span-1 space-y-18 lg:col-span-2">
                    {/* details */}
                    <div className="relative aspect-square lg:w-full lg:h-[94vh]">
                        <Image
                            src={product.thumbnail.url || "/placeholder.svg"}
                            alt={product.title || "Product image"}
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>

                {/* Product Info - در موبایل دوم میاد */}
                <div className="col-span-1 max-lg:hidden">
                    <div className="flex flex-col gap-2 h-full justify-center">
                        <Heading level={1} className="text-3xl">
                            {product.title}
                        </Heading>
                        <p className="text-sm uppercase text-primary-600">{product.color_title}</p>
                    </div>
                </div>
            </div>
            <Container className="space-y-22 py-20">
                <ProductInformation
                    product={product}
                    woodOptions={DEMO_WOOD_OPTIONS}
                    fabricOptions={DEMO_FABRIC_OPTIONS}
                />
                <ProductGallery images={gallery.image_info} product={product} />
                <div>
                    <ProductDetailTabs product={product} />

                    {/* Comments Section */}
                    <ProductComments productId={id} />

                    {/* Tags */}
                    {product.tags && product.tags.length > 0 && (
                        <div className="flex flex-wrap gap-2 items-center">
                            {product.tags.map((tag) => (
                                <Link
                                    key={tag.slug}
                                    href={`/shop/tag/${tag.slug}`}
                                    className="px-3 py-1.5 text-xs border border-primary-300 text-primary-700 hover:border-primary-900 hover:text-foreground transition-all duration-300 no-underline"
                                >
                                    {tag.title}
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </Container>
            {/* <StickyCartBar product={product} /> */}
        </div>
    )
}
